import { useState } from 'react';
import styles from './style.module.scss';

interface Props {
    toggled: boolean;
    setToggle: any;
    disabled?: boolean;
};

function Toggle(props: Props) {
    const { toggled, setToggle, disabled } = props;

    const click = () => {
        if (disabled) return;
        setToggle(!toggled);
    };

    return (
        <div className={styles.wrapper}>
            <div
                onClick={click}
                className={styles.toggle}
                data-toggle-on={toggled}
                data-toggle-disabled={disabled}
            >
                <span className={styles.toggle_btn}></span>
            </div>
        </div>
    );
};

export default Toggle;
